import { track } from 'modules/core/lib/Tracking'

interface Properties {
  [key: string]: string | null | undefined | number
}

interface CostCenterTracking {
  name: string
  status?: string
  legalEntity?: { id: string | number; legalName?: string | null } | null
  code?: string | null | undefined
}

export const trackCostCenterAction = (
  action: string,
  costCenter?: CostCenterTracking | undefined,
  status = ''
) => {
  let properties: Properties = {}
  if (costCenter) {
    const legalEntity = costCenter.legalEntity ? 'Single legal entity' : 'All legal entities'

    properties = {
      costcenter_name: costCenter.name,
      costcenter_legalentity: legalEntity,
      costcenter_code: costCenter.code,
    }
    if (status.length > 0) properties.status = status
  }
  track(action, properties)
}
